module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "id": "innerContainer"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "label": "Email",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.passwordRules,
      "type": "password",
      "label": "Password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n          Login\n          \n      ")])], 1)], 1), _vm._v(" "), _c('v-expand-transition', [_c('v-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginFailed),
      expression: "loginFailed"
    }],
    attrs: {
      "value": true,
      "color": "error",
      "icon": "warning",
      "id": "incorrectLogin",
      "outline": ""
    }
  }, [_vm._v("\n    Login failed.\n  ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b63fca7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/Login.vue
// module id = 216
// module chunks = 1